import _ from "lodash";
import * as yup from "yup";
import * as phoneParser from "phone";
import React, { Component } from "react";
import { Div, Image, Text, Icon, Row, Col, Input } from "atomize";

import CustomContainer from "../common/CustomContainer";
import WebsiteContainer from "../common/WebsiteContainer";
import { Formik } from "formik";

import ImageLazyLoad from "../common/ImageLazyLoad";
import ImageLink from "../common/ImageLink";
import CreatorsModal from "../../modals/CreatorsModal";
import { Button } from "atomize/dist";
import { IsValidUrl } from "../../utilities/helpers";

//link from funtion in twilio to send message from client side
const twilioFunctionURL = "https://corn-shark-9364.twil.io/trend-onboarding";

class CuratedHero extends Component {
  state = { showModal: false };

  formikProps;

  phone_number_validator = yup.object().shape({
    phone_number: yup
      .string()
      .strict()
      .ensure()
      .required("Please enter a phone number.")
      .trim("Please delete leading and trailing spaces.")
      .test("phone", "Please use a valid phone number.", val => {
        return !isNaN(val) && val.length >= 10 && phoneParser(val).length > 0;
      }),
  });

  onSubmit = async values => {
    this.formikProps.setSubmitting(true);

    console.log(values);
    const response = await fetch(twilioFunctionURL, {
      method: "post",
      headers: {
        "Content-type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
      body: new URLSearchParams({
        to: `+1${values.phone_number}`,
        body:
          "It's time to apply for Trend: https://apps.apple.com/us/app/trend-io-influencer-marketing/id1305347467",
      }).toString(),
    });

    if (response.status === 200) {
      this.formikProps.setSubmitting(false);
      this.formikProps.resetForm();
      this.formikProps.setStatus({
        successMessage: "Submitted Successfully. Thank You!",
        errorMessage: null,
      });
    } else {
      const json = await response.json();
      this.formikProps.setSubmitting(false);
      this.formikProps.setStatus({
        successMessage: null,
        errorMessage: "Something went wrong",
      });
    }
  };

  render() {
    const { description, title, label, subImages, subText, bgImg } = this.props;
    return (
      <Div id="creators-hero">
        <ImageLazyLoad bgImg={bgImg.file.url}>
          <ImageLink link="">
            <Div
              bgImg={bgImg.file.url}
              bgSize="cover"
              bgPos={{ xs: "80%", lg: "100% 18%" }}
              h={{ xs: "34.25rem", md: "37.8rem" }}
              pos="relative"
            >
              <Div
                h={{ xs: "0", md: "100%" }}
                w={{ xS: "0", md: "100%" }}
                bg="linear-gradient(180deg, rgba(0,0,0,0.00) 28%, rgba(0,0,0,0.72) 62%)"
              ></Div>
              <Div
                h={{ xs: "100%", md: "0" }}
                bg="linear-gradient(180deg, rgba(0,0,0,0.31) 0%, rgba(0,0,0,0.86) 100%)"
              >
                <Div
                  // pos="absolute"
                  className="curated-hero"
                  bottom={{ xs: "9.25rem", md: "3rem" }}
                  left="0"
                  w="100%"
                  pos={{ md: "absolute" }}
                  h={{ xs: "100%", md: "auto" }}
                  d={{ xs: "flex", md: "block" }}
                  justify="center"
                  align="center"
                >
                  <WebsiteContainer>
                    <CustomContainer p={{ x: { xs: "0", md: "2.5rem" } }}>
                      <Row>
                        <Col size={{ xs: "12", md: "7" }}>
                          <Div
                            pos="relative"
                            p={{ l: { xs: "0", md: "1.75rem" } }}
                          >
                            <Div
                              w="0.6rem"
                              d={{ xs: "none", md: "block" }}
                              h="100%"
                              pos="absolute"
                              top="0"
                              left="0"
                              bg="linear-gradient(251deg, #FFF7E3 0%, #EDD9AB 100%)"
                            />
                            <Div p={{ x: { xs: "1rem", md: "0" } }}>
                              <Text tag="h1" d="none">
                                Creators
                              </Text>
                              <Text
                                textAlign={{ xs: "center", md: "left" }}
                                textSize={{ xs: "caption4", md: "display2" }}
                                textWeight="700"
                                className="hero-heading"
                                m={{ t: "-4px" }}
                                maxW="29.75rem"
                                tag="h1"
                              >
                                {title}
                              </Text>
                              <Text
                                className="hero-text"
                                textAlign={{ xs: "center", md: "left" }}
                                textSize={{ xs: "17px", md: "subheader1" }}
                                maxW="28.625rem"
                                //style={{ lineHeight: "1.75rem" }}//
                                m={{
                                  t: "0.1rem",
                                  b: { xs: "2rem", md: "0" },
                                }}
                              >
                                {/* {content.text1} */}
                                {description}
                              </Text>
                            </Div>
                          </Div>
                        </Col>
                        <Col
                          size={{ xs: "12", md: "5" }}
                          d="flex"
                          justify={{ xs: "center", md: "flex-end" }}
                        >
                          <Div
                            d="flex"
                            flexDir="column"
                            justify="flex-end"
                            h="100%"
                            maxW="25rem"
                            m={{ l: { md: "1.6rem" } }}
                            //uncomment this later
                            w="100%"
                            p={{ x: { xs: "1.25rem" } }}
                          >
                            <Div m={{ t: "0.675rem" }}>
                              <Text
                                textSize="paragraph"
                                textWeight="700"
                                m={{ b: "8px" }}
                              >
                                Text yourself the app now
                              </Text>

                              <Formik
                                ref={form => {
                                  this.formRef = form;
                                }}
                                initialValues={{
                                  phone_number: "",
                                }}
                                onSubmit={this.onSubmit}
                                validationSchema={this.phone_number_validator}
                              >
                                {props => {
                                  const {
                                    values,
                                    touched,
                                    errors,
                                    status,
                                    handleChange,
                                    handleBlur,
                                    submitCount,
                                    isSubmitting,
                                    handleSubmit,
                                  } = props;
                                  this.formikProps = props;

                                  return (
                                    <form onSubmit={handleSubmit}>
                                      <Div
                                        d="flex"
                                        flexDir={{ xs: "column", md: "row" }}
                                      >
                                        <Input
                                          bg="gray200"
                                          h="3.125rem"
                                          rounded="2px"
                                          placeholder="000-000"
                                          name="phone_number"
                                          type="text"
                                          w="100%"
                                          textSize="subheader5"
                                          p={{ l: "4.5rem" }}
                                          border="none"
                                          onChange={handleChange}
                                          onBlur={handleBlur}
                                          value={values.phone_number}
                                          prefix={
                                            <Text
                                              bg="lightGray"
                                              h="100%"
                                              pos="absolute"
                                              left="0"
                                              textSize="subheader5"
                                              w="3.125rem"
                                              p="0 6px"
                                              textColor="black"
                                              d="flex"
                                              align="center"
                                              justify="center"
                                              rounded={{ l: "2px" }}
                                            >
                                              +1
                                            </Text>
                                          }
                                        />
                                        <Button
                                          textWeight="800"
                                          bg="primary"
                                          p="0 1.4rem"
                                          h="3.125rem"
                                          w="auto"
                                          textColor="black"
                                          rounded="2px"
                                          m={{
                                            l: { md: "6px" },
                                            t: { xs: "12px", md: "0" },
                                          }}
                                          style={{ whiteSpace: "nowrap" }}
                                          type="submit"
                                          disabled={isSubmitting}
                                        >
                                          {!isSubmitting ? (
                                            <Text>Join Now</Text>
                                          ) : (
                                            <Icon
                                              name="Loading"
                                              pos="absolute"
                                              top="50%"
                                              left="50%"
                                              transform="translate(-50%, -50%)"
                                              size="18px"
                                              color="white"
                                              m={{ r: "0.5rem" }}
                                            />
                                          )}
                                        </Button>
                                      </Div>
                                      <Text
                                        textColor="success700"
                                        textSize="caption2"
                                        m={{ t: "0.5rem" }}
                                      >
                                        {_.get(status, "successMessage")}
                                      </Text>
                                      <Div
                                        d={
                                          _.get(status, "successMessage")
                                            ? "none"
                                            : "block"
                                        }
                                        m={{ xs: "auto", md: "0" }}
                                      >
                                        <Text
                                          textColor="danger700"
                                          textSize="caption2"
                                          // m={{ b: "1rem" }}
                                          d={
                                            touched.phone_number
                                              ? "block"
                                              : "none"
                                          }
                                        >
                                          {_.get(status, "errorMessage")}
                                        </Text>
                                        {errors.phone_number && (
                                          <Text
                                            textColor="danger700"
                                            textSize="caption2"
                                            m={{ t: "0.5rem" }}
                                          >
                                            {touched.phone_number &&
                                              errors.phone_number}
                                          </Text>
                                        )}
                                      </Div>
                                    </form>
                                  );
                                }}
                              </Formik>

                              {/* <Div
                                dangerouslySetInnerHTML={{
                                  __html: form,
                                }}
                              ></Div> */}
                              {/* <Button
                                bg="primary"
                                hoverBg="primary700"
                                h="3.125rem"
                                rounded="xs"
                                textColor="black"
                                textWeight="bold"
                                fontFamily="secondary"
                                p={{ x: "1.375rem" }}
                                onClick={() =>
                                  this.setState({ showModal: true })
                                }
                              >
                                {label}
                              </Button> */}
                            </Div>
                          </Div>
                        </Col>
                      </Row>
                    </CustomContainer>
                  </WebsiteContainer>
                </Div>
              </Div>
            </Div>
          </ImageLink>
        </ImageLazyLoad>
        <Div bg="#1F1F1F" m={{ t: { xs: "0", md: "-.75rem" } }}>
          <WebsiteContainer>
            <CustomContainer>
              <Div
                bgImg={subImages[1].file.url}
                bgSize="contain"
                bgRepeat="no-repeat"
                //p={{b: "5.25rem"}}
                bgPos="center"
                d={{ xs: "none", md: "block" }}
              >
                <Div
                  d="flex"
                  flexDir={{ xs: "column", md: "row" }}
                  align="center"
                >
                  <Div flexGrow="1 1 20%">
                    <ImageLink link="">
                      <Div
                        // bgImg="/images/Ben_Franklin.png"
                        bgImg={subImages[0].file.url}
                        bgSize="contain"
                        bgRepeat="no-repeat"
                        bgPos="center"
                        p={{ b: "7rem" }}
                        opacity=".76"
                      ></Div>
                    </ImageLink>
                  </Div>
                  {/* <Text
                    flexGrow="1 1 80%"
                    p={{
                      r: { xs: "0", md: "10rem" },
                      t: { xs: "0", md: ".75rem" },
                    }}
                    textWeight="bold"
                    textSize="15px"
                    style={{ lineHeight: "26px" }}
                    textAlign={{ xs: "center", md: "left" }}
                  >
                    In 2019 our creators have earned over{" "}
                    <Text tag="span" textColor="#5BB64E">
                      $150,000
                    </Text>{" "}
                    while partnering with the brands they love. Are you
                    passionate about content creation?
                  </Text> */}
                  <Text
                    flexGrow="1 1 80%"
                    p={{
                      r: { xs: "0", md: "10rem" },
                      t: { xs: "0", md: ".75rem" },
                    }}
                    textWeight="bold"
                    textSize="15px"
                    style={{ lineHeight: "26px" }}
                    textAlign={{ xs: "center", md: "left" }}
                    dangerouslySetInnerHTML={{
                      __html: subText.text,
                    }}
                  ></Text>
                </Div>
              </Div>
            </CustomContainer>
          </WebsiteContainer>
          <Div
            bgImg={subImages[2].file.url}
            bgSize="cover"
            bgRepeat="no-repeat"
            //p={{b: "5.25rem"}}
            bgPos="center"
            d={{ xs: "block", md: "none" }}
          >
            <Div
              d="flex"
              flexDir={{ xs: "column", md: "row" }}
              align="center"
              p={{ y: "2.125rem", x: "1.375rem" }}
            >
              <Div flexGrow="1 1 20%" w="100%">
                <ImageLink link="">
                  <Div
                    bgImg="/images/Ben_Franklin.png"
                    bgSize="contain"
                    bgRepeat="no-repeat"
                    bgPos="center"
                    p={{ b: "4.75rem" }}
                    //w="100%"
                    opacity=".76"
                  ></Div>
                </ImageLink>
              </Div>
              <Text
                flexGrow="1 1 80%"
                p={{
                  r: { xs: "0", md: "10rem" },
                  t: { xs: "0", md: ".75rem" },
                }}
                textWeight="bold"
                textSize="15px"
                style={{ lineHeight: "26px" }}
                textAlign={{ xs: "center", md: "left" }}
                dangerouslySetInnerHTML={{
                  __html: subText.text,
                }}
              ></Text>
            </Div>
          </Div>
        </Div>
        <CreatorsModal
          isOpen={this.state.showModal}
          onClose={() => this.setState({ showModal: false })}
        />
      </Div>
    );
  }
}

export default CuratedHero;
